// Функция для получения цвета игрока в CSS формате
import {hexToColorNumber} from "../other/hexToColorNumber";
import {getPlayerHexColor} from "./getPlayerHexColor";

const colorMap = new Map();

export const getPlayer0xColor = (color) => {
  const existingColor = colorMap.get(color)
  if (existingColor) {
    return existingColor;
  }

  const newColor = hexToColorNumber(getPlayerHexColor(color));
  colorMap.set(color, newColor);

  return newColor;
};